import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import TicketEventsAll from "./TicketEvents.All";
import TicketEventsReviewQueue from "./TicketEvents.ReviewQueue";
import TicketEventsSummary from "./TicketEvents.Summary";

const TicketEvents = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/events"
      render={() => <Redirect to="/snapscan/events/all" />}
    />
    <Route
      path="/snapscan/events/all"
      render={() => <TicketEventsAll {...props} />}
    />
    <Route
      path="/snapscan/events/review_queue"
      render={() => <TicketEventsReviewQueue {...props} />}
    />
    <Route
      path="/snapscan/events/:id/summary"
      render={(routeProps) => (
        <TicketEventsSummary {...props} {...routeProps} />
      )}
    />
  </Switch>
);

export default TicketEvents;
